import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  UIKitIconRegistry,
  downloadIcon,
  homeIcon,
  startOverIcon,
  documentIcon,
  calculatorIcon,
  starIcon,
  searchIcon,
  plusIcon,
  heartIcon,
  chevronLeftIcon,
  chevronRightIcon,
} from '@ui-kit';
import { Router } from '@angular/router';
import { UserService } from '../../service/user.service';
import { DashboardService, DashboardData } from '../../service/dashboard.service';
import { AppService } from '../../../app.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent implements OnInit, OnDestroy {

  data: Partial<DashboardData> = this.dashboard.data;
  dataSubscription: Subscription;

  toggle: boolean;

  window = window;

  constructor(
    private user: UserService,
    private router: Router,
    private dashboard: DashboardService,
    private app: AppService,
    iconRegistry: UIKitIconRegistry,
  ) {
    iconRegistry.registerIcons([
      downloadIcon,
      homeIcon,
      startOverIcon,
      documentIcon,
      calculatorIcon,
      starIcon,
      searchIcon,
      plusIcon,
      heartIcon,
      chevronLeftIcon,
      chevronRightIcon
    ]);
  }

  ngOnInit(): void {
    this.data = this.dashboard.data;
    this.dataSubscription = this.dashboard.events
      .pipe(filter(event => event.type === 'update'))
      .subscribe(event => this.data = event.data);
  }

  ngOnDestroy(): void {
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
      this.dataSubscription = void 0;
    }
  }

  onStartOverClick() {
    this.user
      .updateApplication({ qualifier: null })
      .toPromise()
      .then(() => {
        this.router.navigate(['/'], {
          fragment: 'get-started',
        });
      });
  }

  onAddHomeClick() {
    this.app.event.emit({ type: 'add-a-home' });
  }
}
